import { render, staticRenderFns } from "./ClientsAddresses.vue?vue&type=template&id=731bc76d&scoped=true&"
import script from "./ClientsAddresses.vue?vue&type=script&lang=ts&"
export * from "./ClientsAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731bc76d",
  null
  
)

export default component.exports